(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["document-search"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function initialize(root) {
      if (root.dataset.initialized) return;
      root.dataset.initialized = 'true';
      const form = root.querySelector('form');
      const input = root.querySelector('input');
      const button = root.querySelector('button');
      const status = root.querySelector('.report-status');
      const results = root.querySelector('.report-results');
      const templates = new Map();
      const normalize = value => value.normalize('NFKC').trim().toLowerCase().replace(/[\s\-‐‑‒–—−]/g, '');
      let nextPage = '';
      let total = 0;
      function absorb(section) {
        const source = section.querySelector('.report-source');
        if (!source) throw new Error('Missing report source');
        source.querySelectorAll('template[data-lot]').forEach(template => {
          templates.set(template.dataset.reportHandle, template);
        });
        nextPage = source.dataset.next || '';
        total = Number(source.dataset.total || 0);
      }
      absorb(root);
      const initialSource = root.querySelector('.report-source');
      if (Number(initialSource.dataset.current) > 1) {
        const firstPage = new URL(window.location.href);
        firstPage.searchParams.set(initialSource.dataset.pageParam, '1');
        nextPage = firstPage.href;
      }
      function message(text, error = false) {
        status.textContent = text;
        status.dataset.error = String(error);
      }
      input.addEventListener('input', () => input.removeAttribute('aria-invalid'));
      form.addEventListener('submit', async event => {
        event.preventDefault();
        const lot = normalize(input.value);
        results.replaceChildren();
        if (!lot) {
          input.setAttribute('aria-invalid', 'true');
          message('Please enter the Lot Number.', true);
          input.focus();
          return;
        }
        button.disabled = true;
        root.setAttribute('aria-busy', 'true');
        message('Searching reports…');
        try {
          const visited = new Set();
          while (nextPage) {
            const url = new URL(nextPage, window.location.href);
            if (url.origin !== window.location.origin || visited.has(url.href)) throw new Error('Invalid pagination');
            visited.add(url.href);
            url.searchParams.set('section_id', root.dataset.reportSection);
            const response = await fetch(url.href, { credentials: 'same-origin', signal: AbortSignal.timeout(15000) });
            if (!response.ok) throw new Error('Report request failed');
            const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
            const section = doc.getElementById(root.id);
            if (!section) throw new Error('Report section missing');
            absorb(section);
          }
          if (total >= 25000) throw new Error('Report directory reaches Liquid pagination limit');
          const matches = Array.from(templates.values()).filter(template => normalize(template.dataset.lot) === lot);
          matches.forEach(template => results.append(template.content.cloneNode(true)));
          if (matches.length === 0) message('Report Not Found. Please check your Lot Number and try again.');
          else if (matches.length === 1) message('1 report found.');
          else message(`${matches.length} reports found for this Lot Number. Please check the product name and type.`);
        } catch (error) {
          message('Unable to complete the search. Please try again or contact HIQILI Support.', true);
        } finally {
          button.disabled = false;
          root.removeAttribute('aria-busy');
        }
      });
    }
    const scan = scope => scope.querySelectorAll('.hiqili-reports').forEach(initialize);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(document), { once: true });
    else scan(document);
    document.addEventListener('shopify:section:load', event => scan(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
